<h4 class="p-2 pl-4 mb-4 text-white" mat-dialog-title>&nbsp;{{data.title}}</h4>
<mat-dialog-content class="sen-fs10 pb-2">
    <div fxLayout="row" fxLayoutAlign="flex-start center">
        <div>
            <p><span [style.background-color]="bgColorF" class="sen-color-box d-inline-block"></span>
                {{translate.getLng('ROOF_AREA_F')}}</p>
            <p><span [style.background-color]="bgColorG" class="sen-color-box d-inline-block"></span>
                {{translate.getLng('ROOF_AREA_G')}}</p>
            <p><span [style.background-color]="bgColorH" class="sen-color-box d-inline-block"></span>
                {{translate.getLng('ROOF_AREA_H')}}</p>
        </div>
        <img class="ml-4" src="{{imagePath.ROOF_RANGE}}">
    </div>
    <div class="my-3" *ngIf="(selectedProject$ | async) as project">
        <img src="{{imagePath.windIcon}}" width="12"> &nbsp;
        {{translate.getLng('WINDZONE')}} : <b>{{project.windZone}}</b> &nbsp;&nbsp;
        <img src="{{imagePath.snowIcon}}" width="12"> &nbsp;
        {{translate.getLng('SNOWZONE')}} : <b>{{project.snowZone}}</b> &nbsp;&nbsp;
        <img src="{{imagePath.terrainIcon}}" width="12"> &nbsp;
        {{translate.getLng('TERRAIN_CAT')}} : <b>{{globalF.getInt(project.terrainCategory) + 1}}</b>
    </div>
    <table mat-table #staticsTable class="w-100 mt-3 table" [dataSource]="dataSource">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let element">{{element.name}} </td>
        </ng-container>
        <ng-container matColumnDef="F">
            <th mat-header-cell *matHeaderCellDef> F</th>
            <td mat-cell *matCellDef="let element">{{element.f}} </td>
        </ng-container>
        <ng-container matColumnDef="G">
            <th mat-header-cell *matHeaderCellDef> G</th>
            <td mat-cell *matCellDef="let element">{{element.g}} </td>
        </ng-container>
        <ng-container matColumnDef="H">
            <th mat-header-cell *matHeaderCellDef> H</th>
            <td mat-cell *matCellDef="let element">{{element.h}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</mat-dialog-content>
<mat-dialog-actions class="text-center mt-4 justify-content-end">
    <button mat-raised-button color="primary" class="sen-fs10 px-4"
        (click)="closeDialogue()">{{data.buttons.cancel}}</button>
</mat-dialog-actions>